<template>
  <v-navigation-drawer 
    id="nav-drawer" 
    :value="isOpen && isLoggedIn"
    :clipped="true"
    :mobile-break-point=0
    dark 
    app 
    dense
  >
    <v-list dark>
      <template v-for="(link, i) in links">
        <DrawerEntry 
          :link="link" 
          :key="link.text" 
          :index="i" 
          :selectedCustomer="selectedCustomer"
          :isLoggedIn="isLoggedIn"
        />
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import DrawerEntry from './DrawerEntry'

export default {
  name: "NavDrawer",
  components: {
    DrawerEntry
  },
  props: {
    showDrawer: Boolean,
    links: Array,
    isOpen: Boolean,
    isLoggedIn: Boolean,
    selectedCustomer: Object,
  }
}
</script>

<style>
#nav-drawer {
  background-color: rgba(33,33,33,1);
}
</style>